import {getHeaders} from './xhrRequest';
import {createAction} from 'redux-api-middleware';
import QueryStorage from "../../../../common/helpers/QueryStorage";

export const GET_USER_INIT = 'GET_USER_INIT';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const LOGIN_INIT = 'LOGIN_INIT';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const SIGN_UP_INIT = 'SIGN_UP_INIT';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

export const SOCIAL_LOGIN = 'SOCIAL_LOGIN';
export const SOCIAL_LOGIN_SUCCESS = 'SOCIAL_LOGIN_SUCCESS';
export const SOCIAL_LOGIN_FAILURE = 'SOCIAL_LOGIN_FAILURE';

export const RESET_PASSWORD_INIT = 'RESET_PASSWORD_INIT';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const RESET_PASSWORD_CODE_INIT = 'RESET_PASSWORD_CODE_INIT';
export const RESET_PASSWORD_CODE_SUCCESS = 'RESET_PASSWORD_CODE_SUCCESS';
export const RESET_PASSWORD_CODE_FAILURE = 'RESET_PASSWORD_CODE_FAILURE';

export const RESET_PASSWORD_NEW_PASSWORD_INIT = 'RESET_PASSWORD_NEW_PASSWORD_INIT';
export const RESET_PASSWORD_NEW_PASSWORD_SUCCESS = 'RESET_PASSWORD_NEW_PASSWORD_SUCCESS';
export const RESET_PASSWORD_NEW_PASSWORD_FAILURE = 'RESET_PASSWORD_NEW_PASSWORD_FAILURE';

export const CLEAR_RESET_PASSWORD_STATUS = 'CLEAR_RESET_PASSWORD_STATUS';

export const LOGOUT_INIT = 'LOGOUT_INIT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const SWITCH_NIGHT_MODE_INIT = 'SWITCH_NIGHT_MODE_INIT';
export const SWITCH_NIGHT_MODE_SUCCESS = 'SWITCH_NIGHT_MODE_SUCCESS';
export const SWITCH_NIGHT_MODE_FAILURE = 'SWITCH_NIGHT_MODE_FAILURE';

export const UPDATE_PROFILE_INFO_INIT = 'UPDATE_PROFILE_INFO_INIT';
export const UPDATE_PROFILE_INFO_SUCCESS = 'UPDATE_PROFILE_INFO_SUCCESS';
export const UPDATE_PROFILE_INFO_FAILURE = 'UPDATE_PROFILE_INFO_FAILURE';

export const SET_PASSWORD_INIT = 'SET_PASSWORD_INIT';
export const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS';
export const SET_PASSWORD_FAILURE = 'SET_PASSWORD_FAILURE';

export const TOGGLE_NIGHT_CALLS_INIT = 'TOGGLE_NIGHT_CALLS_INIT';
export const TOGGLE_NIGHT_CALLS_SUCCESS = 'TOGGLE_NIGHT_CALLS_SUCCESS';
export const TOGGLE_NIGHT_CALLS_FAILURE = 'TOGGLE_NIGHT_CALLS_FAILURE';

export const updateProfileInfo = (data) => createAction({
    types: [
        UPDATE_PROFILE_INFO_INIT,
        UPDATE_PROFILE_INFO_SUCCESS,
        UPDATE_PROFILE_INFO_FAILURE,
    ],
    endpoint: '/api/profile/update',
    headers: getHeaders(),
    method: 'PUT',
    body: JSON.stringify(data),
    credentials: 'include',
});

export const setPassword = (data) => createAction({
    types: [
        SET_PASSWORD_INIT,
        SET_PASSWORD_SUCCESS,
        SET_PASSWORD_FAILURE,
    ],
    endpoint: '/api/user/set-password',
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include',
});

export const toggleNightCalls = () => createAction({
    types: [
        TOGGLE_NIGHT_CALLS_INIT,
        TOGGLE_NIGHT_CALLS_SUCCESS,
        TOGGLE_NIGHT_CALLS_FAILURE,
    ],
    endpoint: '/api/user/night-calls/toggle',
    headers: getHeaders(),
    method: 'POST',
    credentials: 'include',
});

export const switchNightMode = (state) => createAction({
    types: [
        SWITCH_NIGHT_MODE_INIT,
        SWITCH_NIGHT_MODE_SUCCESS,
        SWITCH_NIGHT_MODE_FAILURE,
    ],
    endpoint: '/api/user/night-mode/' + (state ? 'enable' : 'disable'),
    headers: getHeaders(),
    method: 'POST',
    credentials: 'include'
});

export const getUser = () => createAction({
    types: [
        GET_USER_INIT,
        {
            type: GET_USER_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return {
                        user: json.hasOwnProperty('status') ? undefined : json,
                        authorized: json.status !== false,
                        // Live geo travels on the user payload (guest + auth),
                        // so it is the single source for the geo-block + phone
                        // defaults - no separate /api/country/iso-code call.
                        ipIsoCode: (json.current_country_code_iso || 'us').toString().toLowerCase(),
                        geoBlocked: !!json.geo_blocked,
                    };
                });
            }
        },
        GET_USER_FAILURE
    ],
    endpoint: `/api/user/user`,
    headers: getHeaders(),
    method: 'GET',
    credentials: 'include'
});

export const login = data => createAction({
    types: [
        LOGIN_INIT,
        {
            type: LOGIN_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return {
                        user: json,
                        authorized: true,
                    };
                });
            }
        },
        LOGIN_FAILURE
    ],
    endpoint: `/api/user/sign-in`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});

export const signUp = data => createAction({
    types: [
        SIGN_UP_INIT,
        {
            type: SIGN_UP_SUCCESS,
            payload: (action, state, res) => {
                QueryStorage.set('newcomer', '1');
                return res.json().then(json => {
                    return {
                        user: json,
                        authorized: true,
                    };
                });
            }
        },
        SIGN_UP_FAILURE
    ],
    endpoint: `/api/user/sign-up`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});

export const socialAuth = data => createAction({
    types: [
        {
            type: SOCIAL_LOGIN,
            payload: {
                showPreloader: true,
            }
        },
        {
            type: SOCIAL_LOGIN_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return {
                        user: json,
                        authorized: true,
                    };
                });
            }
        },
        SOCIAL_LOGIN_FAILURE
    ],
    endpoint: `/api/user/social-auth`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});

export const resetPassword = data => createAction({
    types: [
        RESET_PASSWORD_INIT,
        {
            type: RESET_PASSWORD_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return {
                        response: json,
                        success: !!json.success,
                        error: json.error || null,
                    };
                });
            }
        },
        RESET_PASSWORD_FAILURE
    ],
    endpoint: `/api/user/reset-password/request`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});

export const resetPasswordCode = data => createAction({
    types: [
        RESET_PASSWORD_CODE_INIT,
        {
            type: RESET_PASSWORD_CODE_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return {
                        response: json,
                        success: !!json.success,
                        error: json.error || null,
                    };
                });
            }
        },
        RESET_PASSWORD_CODE_FAILURE
    ],
    endpoint: `/api/user/reset-password/code`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});

export const resetPasswordNewPassword = data => createAction({
    types: [
        RESET_PASSWORD_NEW_PASSWORD_INIT,
        {
            type: RESET_PASSWORD_NEW_PASSWORD_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return {
                        response: json,
                        success: !!json.success,
                        error: json.error || null,
                    };
                });
            }
        },
        RESET_PASSWORD_NEW_PASSWORD_FAILURE
    ],
    endpoint: `/api/user/reset-password/new-password`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});

export const logout = () => createAction({
    types: [
        LOGOUT_INIT,
        LOGOUT_SUCCESS,
        LOGOUT_FAILURE
    ],
    endpoint: `/api/user/logout`,
    headers: getHeaders(),
    method: 'POST',
    credentials: 'include'
});
